"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEVELOPMENT_DEPENDENCIES = exports.AssetStatus = exports.ASSET_DELETED_STATUS = void 0;
var AssetStatus = exports.AssetStatus = /*#__PURE__*/function (AssetStatus) {
  AssetStatus["PUBLISHED"] = "published";
  AssetStatus["DEPRECATED"] = "deprecated";
  AssetStatus["DEVELOPMENT"] = "development";
  AssetStatus["DELETED"] = "deleted";
  AssetStatus["HARD_DELETED"] = "hard-deleted";
  return AssetStatus;
}({});
var ASSET_DELETED_STATUS = exports.ASSET_DELETED_STATUS = [AssetStatus.DELETED.toString(), AssetStatus.HARD_DELETED.toString()];
var DEVELOPMENT_DEPENDENCIES = exports.DEVELOPMENT_DEPENDENCIES = 'DEVELOPMENT_DEPENDENCIES';
//# sourceMappingURL=types.js.map